import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSVerifyPhoneOtpSubmitOutput, type EnrollmentHYCSVerifyPhoneData } from '../../../../models'

// Safe fallback for window object
const getWindowPathname = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.pathname
  }
  return ''
}

const getParentPath = (): string => {
  const pathname = getWindowPathname()
  return pathname.split('/').slice(0, -1).join('/')
}

export const getEnrollmentHYCSVerifyPhoneDataMock: EnrollmentHYCSVerifyPhoneData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: getWindowPathname(),
  enrollmentData: {
    applicationId: '1234',
    phoneNumber: '+1 (987) 654-3210',
  },
}

export const submitEnrollmentHYCSVerifyPhoneDataMock: EnrollmentHYCSVerifyPhoneOtpSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: `${getParentPath()}/home-address`,
  enrollmentData: {
    applicationId: '1234',
    phoneNumber: '+1 (987) 654-3210',
  },
}

export const mockGetEnrollmentHYCSVerifyPhoneData = graphql.mutation('getEnrollmentHYCSVerifyPhoneData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSVerifyPhoneDataMock } })
})

export const mockSubmitEnrollmentHYCSVerifyPhoneData = graphql.mutation('submitEnrollmentHYCSVerifyPhoneData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSVerifyPhoneDataMock } })
})

export const mockEnrollmentHYCSVerifyPhone = [
  mockGetEnrollmentHYCSVerifyPhoneData,
  mockSubmitEnrollmentHYCSVerifyPhoneData,
]
